import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import { postEvent } from "@telegram-apps/sdk";
import { useAtom } from "jotai";

import { useTranslation } from "@arc/i18n";
import { useTonWallet } from "@arc/sdk";
import { sleep } from "@arc/shared/utils/sleep";

import { tonConnectParamsAtom } from "@/atoms/tonConnect";
import { useConnectionResponseMutation } from "@/utils/tonConnect/hooks";
import { type ConnectItemReply, type DAppManifest } from "@/utils/tonConnect/types";

import { TonConnectModal } from "../TonConnectModal";
import { WalletsListModal } from "../Wallet/WalletsListModal";

export const InitTcConnectionsListener = () => {
  const { t } = useTranslation("wallet");
  const [params, setParams] = useAtom(tonConnectParamsAtom);
  const [walletsListIsOpen, setWalletsListIsOpen] = useState(false);

  const activeWallet = useTonWallet();

  const { mutateAsync: handleTonConnect } = useConnectionResponseMutation();

  useEffect(() => {
    if (!params) return;

    if (!activeWallet) {
      toast.error(t("ERRORS.WALLET_NOT_CONNECTED"), { duration: 8000 });
      setParams(null);
    }
  }, [t, activeWallet, params, setParams]);

  const handleClose = async (replyItems?: ConnectItemReply[], manifest?: DAppManifest) => {
    if (!params) return;

    if (!replyItems && !manifest) {
      setParams(null);
    }

    try {
      await await handleTonConnect({
        params,
        replyItems,
        manifest,
      });

      if (params.needReturnBack) {
        await sleep(1000);
        postEvent("web_app_close");
      }
    } catch (error) {
      console.error(error);
      toast.error(t("TONCONNECT.CANT_CONNECT"));
    }

    setParams(null);
  };

  return (
    <>
      <TonConnectModal
        hideButton={walletsListIsOpen}
        isOpen={!!params}
        params={params?.request ?? null}
        onAccountClick={() => {
          setWalletsListIsOpen(true);
        }}
        onClose={handleClose}
      />

      <WalletsListModal
        hideButton
        isOpen={walletsListIsOpen}
        onClose={() => {
          setWalletsListIsOpen(false);
        }}
      />
    </>
  );
};
